import React from "react";
import Section from "../components/Section";
import { Button, Popover, PopoverList, Typography } from "../components";
import { CaretDown, CaretRight } from "@phosphor-icons/react";
import { ISelectInput } from "../models";

const PopoverSection = () => {
	const [selectedItem, setSelectedItem] = React.useState<ISelectInput>();
	const handleClickPopoverButton = () => {
		console.log("Button Clicked");
	};
	return (
		<Section title={"#Popover"}>
			<Typography>Popover - click</Typography>
			<div className="d-flex gap3 mb-3 flex-wrap">
				<Popover
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={"Bottom Right"}
						/>
					}
					position="bottom-right"
					parentClass="p-2"
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
					<Button label="Close" onClick={handleClickPopoverButton} variant={"secondary"} />
				</Popover>
				<Popover
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={"Bottom Left"}
						/>
					}
					position="bottom-left"
					parentClass="p-2"
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
				</Popover>
				<Popover
					target={
						<Button variant="secondary" iconPosition="right" rightIcon={<CaretDown weight="bold" />} onClick={() => {}} label={"Top"} />
					}
					position="top"
					parentClass="p-2"
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
				</Popover>
				<Popover
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={"Bottom"}
						/>
					}
					position="bottom"
					parentClass="p-2"
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
				</Popover>
				<Popover
					target={
						<Button variant="secondary" iconPosition="right" rightIcon={<CaretDown weight="bold" />} onClick={() => {}} label={"Left"} />
					}
					position="left"
					parentClass="p-2"
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
				</Popover>
				<Popover
					target={
						<Button variant="secondary" iconPosition="right" rightIcon={<CaretDown weight="bold" />} onClick={() => {}} label={"Right"} />
					}
					position="right"
					parentClass="p-2"
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
				</Popover>
			</div>
			<Typography>Popover - hover</Typography>
			<div className="d-flex gap3 mb-3 flex-wrap">
				<Popover
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={"Hover Me"}
						/>
					}
					position="bottom-right"
					parentClass="p-2"
					hoverTrigger={true}
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
				</Popover>
				<Popover
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={"Hover Me"}
						/>
					}
					position="bottom-right"
					parentClass="p-2"
					hoverTrigger={true}
					disableHoverOut={true}
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">This popup will not close on Hover Out</Typography>
					</div>
				</Popover>
			</div>
			<Typography>Popover - click - Close on inside click</Typography>
			<div className="d-flex gap3 mb-3 flex-wrap">
				<Popover
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={"Bottom Right"}
						/>
					}
					position="bottom-right"
					parentClass="p-2"
					enableCloseOnInsideClick
				>
					<Typography type="text" size="lg">
						Popup Title
					</Typography>
					<div>
						<Typography color="muted">Popover content</Typography>
					</div>
					<Button label="Close" onClick={handleClickPopoverButton} variant={"secondary"} />
				</Popover>
			</div>
			<Typography>Popover - Select list item</Typography>
			<div className="d-flex gap3 mb-3 flex-wrap ml-5 pl-5">
				<PopoverList
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={selectedItem ? selectedItem.label : "Select "}
						/>
					}
					position="bottom"
					value={selectedItem}
					setValue={setSelectedItem}
					selectOptions={options}
				></PopoverList>
				<PopoverList
					target={
						<Button
							variant="secondary"
							iconPosition="right"
							rightIcon={<CaretDown weight="bold" />}
							onClick={() => {}}
							label={selectedItem ? selectedItem.label : "Disabled"}
							disabled
						/>
					}
					position="bottom"
					value={selectedItem}
					setValue={setSelectedItem}
					selectOptions={options}
					disabled
				></PopoverList>
			</div>
		</Section>
	);
};
const options = [
	{ label: "Option 1", value: "option1" },
	{ label: "Option 2", value: "option2" },
	{ label: "Option 3", value: "option3" },
	{ label: "Option 4", value: "option4" }
];
export default PopoverSection;
